<template>
  <div id="blackList">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <!--<th scope="col">
            Nombre de Usuario
          </th>-->
          <!--<th scope="col">
            Fecha alta
          </th>-->
          <th scope="col" class="align-middle">
            DNI
          </th>
          <th scope="col" class="align-middle">
            Apellido
          </th>
          <th scope="col" class="align-middle">
            Teléfono
          </th>
          <th scope="col" class="align-middle">
            Email
          </th>
          <th scope="col" class="align-middle">
            Calle
          </th>
          <th scope="col" class="align-middle">
            Número
          </th>
          <th scope="col" class="align-middle">
            Código postal
          </th>
          <th scope="col" class="align-middle">
            Ciudad
          </th>
          <th scope="col" class="align-middle">
            Provincia
          </th>
          <th scope="col" class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(blackListAux, index) in blackListAuxArray" v-bind:key="index">
          <!--<td class="align-middle py-4">{{ blackListAux.name!=null?blackListAux.name:'-' }}</td>-->
          <!--<td class="align-middle py-4">{{ blackListAux.date!=null?blackListAux.date:'-' }}</td>-->
          <td class="align-middle py-4">{{
            blackListAux.legalIdentifier != '' && blackListAux.legalIdentifier != null ?
              blackListAux.legalIdentifier : '-'
          }}
            <button type="button" class="btn btn-link" @click="editData(blackListAux,'editLegalIdentifier')" 
              v-if="(blackListAux.legalIdentifier != '' && blackListAux.legalIdentifier != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
          </td>
          <td class="align-middle py-4">{{
            blackListAux.surname != '' && blackListAux.surname != null ?
              blackListAux.surname : '-'
          }}
            <button type="button" class="btn btn-link" @click="editData(blackListAux,'editSurname')" v-if="(blackListAux.surname != '' && blackListAux.surname != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
          </td>
          <td class="align-middle py-4">{{
            blackListAux.mobile != '' && blackListAux.mobile != null ?
              blackListAux.mobile
              : '-'
          }}
            <button type="button" class="btn btn-link" @click="editData(blackListAux,'editMobile')" v-if="(blackListAux.mobile != '' && blackListAux.mobile != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
          </td>
          <td class="align-middle py-4">{{
            blackListAux.email != '' && blackListAux.email != null ? blackListAux.email :
              '-'
          }}
            <button type="button" class="btn btn-link" @click="editData(blackListAux,'editEmail')" v-if="(blackListAux.email != '' && blackListAux.email != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
          </td>
          <td class="align-middle py-4">{{
            blackListAux.street != '' && blackListAux.street != null ?
              blackListAux.street : '-'
          }}</td>
          <td class="align-middle py-4">{{
            blackListAux.number != '' && blackListAux.number != null ?
              blackListAux.number : '-'
          }}</td>
          <td class="align-middle py-4">{{
            blackListAux.postalCode != '' && blackListAux.postalCode != null ?
              blackListAux.postalCode : '-'
          }}</td>
          <td class="align-middle py-4">{{
            blackListAux.city != '' && blackListAux.city != null ? blackListAux.city :
              '-'
          }}</td>
          <td class="align-middle py-4">{{
            blackListAux.province != '' && blackListAux.province != null ?
              blackListAux.province : '-'
          }}</td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#" @click="cargarListaAux(blackListAux)">Eliminar
                  Registro</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(blackListAux, index) in blackListAuxArray" v-bind:key="index">  
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ blackListAux.email != '' && blackListAux.email != null ? blackListAux.email : '-' }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>DNI: </strong>{{ blackListAux.legalIdentifier != '' && blackListAux.legalIdentifier != null ? blackListAux.legalIdentifier : '-' }}</p>
                <button type="button" class="btn btn-link" @click="editData(blackListAux,'editLegalIdentifier')" 
                  v-if="(blackListAux.legalIdentifier != '' && blackListAux.legalIdentifier != null)"><v-icon
                    name="md-modeeditoutline" scale="1" /></button>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#" @click="cargarListaAux(blackListAux)">Eliminar
                      Registro</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Apellido: </strong>{{ blackListAux.surname != '' && blackListAux.surname != null ? blackListAux.surname : '-' }}</p>
              <button type="button" class="btn btn-link" @click="editData(blackListAux,'editSurname')" v-if="(blackListAux.surname != '' && blackListAux.surname != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Teléfono: </strong>{{ blackListAux.mobile != '' && blackListAux.mobile != null ? blackListAux.mobile : '-' }}</p>
              <button type="button" class="btn btn-link" @click="editData(blackListAux,'editMobile')" v-if="(blackListAux.mobile != '' && blackListAux.mobile != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Email: </strong>{{ blackListAux.email != '' && blackListAux.email != null ? blackListAux.email : '-' }}</p>
              <button type="button" class="btn btn-link" @click="editData(blackListAux,'editEmail')" v-if="(blackListAux.email != '' && blackListAux.email != null)"><v-icon
                name="md-modeeditoutline" scale="1" /></button>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Calle: </strong>{{ blackListAux.street != '' && blackListAux.street != null ? blackListAux.street : '-' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Número: </strong>{{ blackListAux.number != '' && blackListAux.number != null ? blackListAux.number : '-' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Código postal: </strong>{{ blackListAux.postalCode != '' && blackListAux.postalCode != null ? blackListAux.postalCode : '-' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Ciudad: </strong>{{ blackListAux.city != '' && blackListAux.city != null ? blackListAux.city : '-' }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Provincia: </strong>{{ blackListAux.province != '' && blackListAux.province != null ? blackListAux.province : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <UserDelete :id="'deleteRegister'" :modalTitle="'ELIMINAR USUARIO'" :showFooter="false" :endpoint="endpointDelete"
      @refreshRegisterList="refreshRegisterList($event)">
    </UserDelete>
    <EditLegalIdentifier :id="'editLegalIdentifier'" :modalTitle="'EDITAR DNI'" :showFooter="false" :list="list"
      @refreshRegisterList="refreshRegisterList($event)">
    </EditLegalIdentifier>
    <EditMobile :id="'editMobile'" :modalTitle="'EDITAR TELÉFONO'" :showFooter="false" :list="list"
      @refreshRegisterList="refreshRegisterList($event)">
    </EditMobile>
    <EditEmail :id="'editEmail'" :modalTitle="'EDITAR EMAIL'" :showFooter="false" :list="list"
      @refreshRegisterList="refreshRegisterList($event)">
    </EditEmail>
    <EditSurname :id="'editSurname'" :modalTitle="'EDITAR APELLIDO'" :showFooter="false" :list="list"
      v-if="showModalEditSurname"
			@closeModal="showModalEditSurname = false"
      @refreshRegisterList="refreshRegisterList($event)">
    </EditSurname>
  </div>
</template>

<script>
import UserDelete from './DeleteFromBlackList.vue';
import EditLegalIdentifier from './EditLegalIdentifier.vue';
import EditMobile from './EditMobile.vue';
import EditEmail from './EditEmail.vue';
import EditSurname from './EditSurname.vue';
import { Modal as ModalBootstrap } from "bootstrap";
export default {
  name: 'UsersList',
  props: [
    'blackList',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      blackListAuxArray: this.blackList,
      blackListAuxCheck: '',
      list: '',
      endpointDelete: '',
      showModalEditSurname: false,
    };
  },
  updated() {
    this.blackListAuxArray = this.blackList
  },
  components: {
    UserDelete,
    EditLegalIdentifier,
    EditMobile,
    EditEmail,
    EditSurname
  },
  methods: {
    editData(list,identifier) {
      this.list = list;
      if(identifier === "editSurname") {
        this.showModalEditSurname = true;
      }
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById(identifier))
        myModal.show()
      })
    },
    refreshRegisterList(event) {
      this.$emit("sendRefreshRegisterList", event);
    },
    cargarListaAux(list) {
      if (list.legalIdentifier != '' && list.legalIdentifier != null) {
        this.endpointDelete = 'blacklist-delete/' + list.legalIdentifier
      } else if (list.mobile != '' && list.mobile != null) {
        this.endpointDelete = 'blacklist-delete-mobile/' + list.mobile
      } else if (list.email != '' && list.email != null) {
        this.endpointDelete = 'blacklist-delete-email/' + list.email
      }else if (list.surname != '' && list.surname != null) {
        this.endpointDelete = 'blacklist-delete-surname/' + list.surname
      } else if (list.street != '' && list.street != null) {
        this.endpointDelete = `blacklist-delete-address/${list.street}/${list.number}/${list.postalCode}`
      }
      var myModal = new ModalBootstrap(document.getElementById('deleteRegister'))
      myModal.show()
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.btn.btn-link:focus {
  outline: none;
  box-shadow: none;
}

#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}
</style>
